import { render, staticRenderFns } from "./RecipeReviewCard.vue?vue&type=template&id=5d3b01d0&scoped=true&"
import script from "./RecipeReviewCard.vue?vue&type=script&lang=js&"
export * from "./RecipeReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./RecipeReviewCard.vue?vue&type=style&index=0&id=5d3b01d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b01d0",
  null
  
)

export default component.exports